export default {
      id: "file-document-check-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.95404f0a.svg#file-document-check",
      toString: function () {
        return this.url;
      }
    }